export default __webpack_public_path__ + "static/media/notFound.c8d4e66b.svg";